class apiData {
  constructor() {
    this.page = "";
    this.store = null;
    this.data = null;
  }
}

export default apiData;
